export const adVehicleFetchIntervalInMs = 1000
